"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummaryTablePresenterImpl = void 0;
const common_1 = require("../common/common");
const MAX_USER_ROWS_WITHOUT_DYNAMIC_RENDER = 50;
class SummaryTablePresenterImpl {
    viewModel;
    constructor() { }
    setViewModel(vm) {
        this.viewModel = vm;
    }
    initEmployeeStats(branchSettings, lockStatsColumnViews, showUserAlertBadges, roles) {
        if (!this.viewModel) {
            return;
        }
        const statsSettings = {
            roleCounts: [],
            showEmployeeWorkCountCell: branchSettings.isWorkCountInSummaryPage,
            showEmployeeVacationCountCell: branchSettings.isVacationCountInSummaryPage,
            showEmployeePTOCountCell: branchSettings.isPTOCountInSummaryPage,
            showEmployeeLaborCountCell: branchSettings.isLaborInSummaryPage,
            showStatsLock: lockStatsColumnViews,
            showUserAlertBadges,
        };
        roles.forEach(r => {
            statsSettings.roleCounts.push({
                id: r.getOriginalId(),
            });
        });
        this.viewModel.stats = statsSettings;
    }
    initDates(dates) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.oplusTimeDateStrings = dates.map(d => (0, common_1.yearMonthDateString)((0, common_1.toOplusTime)(d.getDate()), 'UTC'));
    }
    initEmployeeRows(userRows, showMemo, path, branchId) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.showMemoSummary = showMemo;
        if (userRows.length > MAX_USER_ROWS_WITHOUT_DYNAMIC_RENDER) {
            // Only render user rows that are in scrolled view.
            this.viewModel.tryUseDynamicRendering = true;
        }
        const rows = [];
        // For now, expect the employee rows have already been sorted.
        userRows.forEach(dashView => {
            rows.push(this.dashViewToViewModel(dashView, showMemo, path, branchId));
        });
        this.viewModel.employeeRows = rows;
    }
    dashViewToViewModel(u, showMemo, path, activeBranchId) {
        return {
            userId: u.userId,
            name: u.name || u.userId.toString(),
            link: `${path}/user/${u.userId}?c=${activeBranchId}`,
            tags: u.tags.map(t => t.string),
            isBranchOwner: u.isBranchOwner || false,
            isFake: u.isFake,
            isHelp: u.isHelp,
            isDeleted: u.isDeleted,
            showMemoSummary: showMemo,
            memo: u.memo,
        };
    }
    handleCellHover(userId, date) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.hoveredUserId = userId;
        this.viewModel.hoveredDate = date;
    }
    handleCellHoverEnd() {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.hoveredUserId = 0;
        this.viewModel.hoveredDate = "";
    }
}
exports.SummaryTablePresenterImpl = SummaryTablePresenterImpl;
